<bit-card class="tw-size-full tw-flex tw-flex-col">
  <!-- Title -->
  <h3 bitTypography="h3" class="tw-m-0 tw-mb-4">{{ "additionalOptions" | i18n }}</h3>

  <!-- Description -->
  <p bitTypography="body1" class="tw-m-0 tw-mb-4 tw-text-main">
    {{ "additionalOptionsDesc" | i18n }}
  </p>

  <!-- Action Buttons -->
  <div class="tw-flex tw-gap-4">
    <button
      bitButton
      buttonType="secondary"
      type="button"
      [disabled]="downloadLicenseDisabled()"
      (click)="callToActionClicked.emit(actions.DownloadLicense)"
    >
      {{ "downloadLicense" | i18n }}
    </button>
    <button
      bitButton
      buttonType="danger"
      type="button"
      [disabled]="cancelSubscriptionDisabled()"
      (click)="callToActionClicked.emit(actions.CancelSubscription)"
    >
      {{ "cancelSubscription" | i18n }}
    </button>
  </div>
</bit-card>
